const MenuList = [
  {
    href: "/",
    text: "Home",
  },
  {
    href: "/servicios",
    text: "Servicios",
  },
  {
    href: "/quienes-somos",
    text: "Quienes somos",
  },
  {
    href: "/casos-de-exito",
    text: "Casos de éxito",
  },
  {
    href: "/contacto",
    text: "Contacto",
  },
];

export default MenuList;
